import styled, { css } from 'styled-components'
import { AlertTriangle } from 'react-feather'

const text = css`
  font-size: 14px;
  font-family: Work Sans;
`

export const Icon = styled(AlertTriangle)`
  color: white;
  width: 26px;
  height: 30px;
`

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 10px 40px;
`

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-around;
  flex: 1 1 100%;
  margin: 1rem 0 0.5rem;
`

export const InfoContainer = styled.div`
  border-radius: 0px 8px 8px 0px;
  border-left: ${({ theme }) => `6px solid ${theme.colors.orange}`};
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightOrange};
`

export const InfoRow = styled.div`
  display: flex;
  flex: 1;
`

export const LabelColumn = styled.div`
  display: flex;
  flex: 0.42;
  justify-content: flex-end;
  text-align: right;
`

export const ValueColumn = styled.div`
  display: flex;
  flex: 0.4;
  justify-content: flex-end;
`

export const Label = styled.span`
  ${text}
  font-weight: bold;
`

export const Value = styled.span`
  ${text}
  margin-left: 1rem;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0rem 0rem 0.5rem;
  row-gap: 0.5rem;
`

export const Text = styled.span`
  ${text}
`

export const PercentageColumn = styled.div`
  display: flex;
  flex: 0.2;
  justify-content: flex-end;
`

export const Percentage = styled.span`
  ${text}
`

export const Field = styled.div`
  width: 100%;
  margin: 1.5rem 0 0 0;

  & > input {
    height: 1.75rem;
    width: 90%;
    border: 1px solid #e1e1e1;
    border-radius: 8px;
    background-color: #f3f3f3;
  }

  & > p {
    max-width: 90%;
  }
`

export const Form = styled.div`
  margin: 0;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const InputLabel = styled.label`
  ${text}
  padding-right: 1rem;
  margin: 0;
  width: 50%;
  padding-bottom: 0.5rem;
`

export const ButtonStyle = {
  fontFamily: 'Work Sans',
  fontWeight: 'bold',
  fontSize: '16px',
}
